import api from './api';

export const listUser = async (
  agencyId,
  page,
  pageSize,
  searchTerm,
  includeCounts,
  workspaceTagId,
  workspaceId,
) => {
  try {
    let requestUrl = `/user/lightweights?page=${page}&pageSize=${pageSize}`;
    if (searchTerm?.length > 0) {
      requestUrl += `&searchTerm=${searchTerm}`;
    }
    if (includeCounts) {
      requestUrl += `&includeCounts=${includeCounts}`;
    }
    if (workspaceTagId?.length > 0) {
      requestUrl += `&workspaceTagId=${workspaceTagId}`;
    }
    if (workspaceId?.length > 0) {
      requestUrl += `&workspaceId=${workspaceId}`;
    }
    return await api.get(requestUrl, { headers: { 'x-agency-id': agencyId } });
  } catch (error) {
    console.log('Error getting list of users: ', error);
    throw error;
  }
};

export const getWorkspaceTagIdsForUser = async (agencyId, userId) => {
  try {
    return await api.get(`/api/v1/user/${userId}/workspacetags`, {
      headers: { 'x-agency-id': agencyId },
    });
  } catch (error) {
    console.log('Error getting workspace tags for user', error);
    throw error;
  }
};

export const updateUser = async (user, agencyId) => {
  try {
    return await api.post('/rest/dashboard/user/update', { user });
  } catch (error) {
    console.log('Error updating user', error);
    throw error;
  }
};

export const fetchCurrentUser = async () => {
  try {
    return await api.get('/user/');
  } catch (error) {
    console.log('Error fetching user', error);
    throw error;
  }
};

export const getWorkspaceCountForUser = async (userId, agencyId) => {
  try {
    return await api.get(`/user/${userId}/workspace/count`, {
      headers: { 'x-agency-id': agencyId },
    });
  } catch (error) {
    console.log('Error workspace count', error);
    throw error;
  }
};
